// Note: We could not just use `New URL(xxx)` to check, for the back-end allows omit protocal. See `FixProtocol` for more information
// You might notice there is not any useful comment -- this is by design! You should read the origional C# code.

import { Uri } from '../CSharpPort/Uri.cs';

enum MarkerMatchType {
  NoMarkers = 0,
  MatchingMarkers = 1,
  NonMatchingMarkers = 2
}

export enum UrlValidationError {
  InvalidUrlProtocol,
  NonMatchingBracesInUrl,
  InvalidUrlFormat,
  LoopbackUrl
}

const UriProtocolSeparator = Uri.SchemeDelimiter;
const HttpPrefix = Uri.UriSchemeHttp + UriProtocolSeparator;
const HttpsProtocolPrefix = Uri.UriSchemeHttps + UriProtocolSeparator;

const DecimalNumberRegex: RegExp = new RegExp('^(\\d+\\.){0,2}\\d+$');

const OpeningMarker = '{';
const ClosingMarker = '}';

const separator = ['\u002E', '\u3002', '\uFF61', '\uFF0E'];

// ATTENTION!!!!
// The function signature and implementation is different with origin c# function, only try to keep same logic
// Origin function is `IsValidUrl`
export function ValidUrl(inputUrl: string): UrlValidationError | undefined {
  const match = GetBraceMatchStatus(inputUrl);
  if (match === MarkerMatchType.MatchingMarkers) {
    return undefined;
  }
  if (DecimalNumberRegex.test(inputUrl)) {
    return UrlValidationError.InvalidUrlFormat;
  }
  // eslint-disable-next-line no-param-reassign
  inputUrl = FixProtocol(inputUrl);
  let resultUri: URL | undefined;
  try {
    resultUri = new URL(inputUrl)
  // eslint-disable-next-line no-empty
  } catch (error) { }
  if (resultUri) {
    if (resultUri.protocol !== (`${Uri.UriSchemeHttp}:`) && resultUri.protocol !== (`${Uri.UriSchemeHttps}:`)) {
      return UrlValidationError.InvalidUrlProtocol;
    }

    // NOT CHECK LOOPBACK ON FRONT-END NOW.

    const labels = resultUri.host.split(new RegExp(`${separator.map(s => `\\${s}`).join('|')}`));
    if (labels.length === 1) {
      return UrlValidationError.InvalidUrlFormat;
    }

    return undefined;
  }
  return UrlValidationError.InvalidUrlFormat;
}

function GetBraceMatchStatus(word: string): MarkerMatchType {
  let openingMarkercount: number = 0;
  let closingMarkerCount: number = 0;
  if (word) {
    for (let index = 0; index < word.length && openingMarkercount >= closingMarkerCount; index++) {
      const char = word[index];
      if (char === OpeningMarker) openingMarkercount += 1;
      else if (char === ClosingMarker) closingMarkerCount += 1;
    }
    if (openingMarkercount > 0 || closingMarkerCount > 0) {
      return openingMarkercount === closingMarkerCount ? MarkerMatchType.MatchingMarkers : MarkerMatchType.NonMatchingMarkers;
    }
  }

  return MarkerMatchType.NoMarkers;
}

function FixProtocol(inputURL: string): string {
  if (inputURL != null
    && !inputURL.toLowerCase().startsWith(HttpPrefix)
    && !inputURL.toLowerCase().startsWith(HttpsProtocolPrefix)
  ) {
    let prefixDefaultProtocol = false;
    const protocolIndex = inputURL.indexOf(UriProtocolSeparator);
    if (protocolIndex !== -1) {
      const scheme: string = inputURL.substring(0, protocolIndex);
      if (!Uri.CheckSchemeName(scheme)) {
        prefixDefaultProtocol = true;
      }
    } else {
      prefixDefaultProtocol = true;
    }

    if (prefixDefaultProtocol) {
      // eslint-disable-next-line no-param-reassign
      inputURL = HttpPrefix + inputURL;
    }
  }
  return inputURL;
}
